<template>
  <v-card elevation="0">
    <v-card-title>Данные справочников r_keeper </v-card-title>
    <v-card-text>
      <v-row class="d-flex" dense>
        <v-col class="col-4">
          <v-select
            v-model="rk7RefConfig.cash_station"
            label="Код кассовой станции"
            :items="rk_refs.cashes"
            item-text="Title"
            item-value="Code"
          ></v-select>
        </v-col>
        <v-col class="col-4">
          <v-select
            v-model="rk7RefConfig.table"
            :items="rk_refs.tables"
            item-text="Title"
            item-value="Code"
            label="Код стола для создания заказов"
          ></v-select>
        </v-col>
        <v-col class="col-4">
          <v-select
            v-model="rk7RefConfig.order_category"
            label="Код категории заказа"
            hint="Если не передан в запросе будет использоваться по стандарту который указан в файле конфигурации, используется для подсчёта стоимости блюд"
            persistent-hint
            :items="rk_refs.order_categories"
            item-text="Title"
            item-value="Code"
          ></v-select>
        </v-col>
        <v-col class="col-4">
          <v-select
            v-model="rk7RefConfig.menu_classification"
            label="Код классификации блюд для выгрузки меню"
            :items="rk_refs.classificator_groups"
            item-text="Title"
            item-value="Code"
          ></v-select>
        </v-col>
        <v-col class="col-4">
          <v-select
            v-model="rk7RefConfig.sum_discount"
            label="Код суммовой скидки Скидка 'на заказ' c изменяемым значением"
            :items="rk_refs.discounts"
            item-text="Title"
            item-value="Code"
          ></v-select>
        </v-col>
        <v-col class="col-4">
          <v-select
            v-model="rk7RefConfig.sum_markup"
            label="Код суммовой наценки Наценка 'на заказ' c изменяемым значением"
            :items="rk_refs.markups"
            item-text="Title"
            item-value="Code"
          ></v-select>
        </v-col>
        <v-col class="col-4">
          <v-select
            v-model="rk7RefConfig.interface"
            label="Код интерфейса для применения карты"
            :items="rk_refs.devices"
            item-text="Title"
            item-value="Code"
          ></v-select>
        </v-col>
        <v-col class="col-4">
          <v-switch
            v-model="rk7RefConfig.close_paid_order"
            label="Закрывать сбалансированный заказ"
          ></v-switch>
        </v-col>
        <v-col class="col-4">
          <v-select
            v-model="rk7RefConfig.cashier_code"
            label="Код кассира от которого будет происходить оплата заказа"
            :items="rk_refs.employees"
            item-text="Title"
            item-value="Code"
          ></v-select>
        </v-col>
        <v-col class="col-4">
          <v-select
            v-model="rk7RefConfig.manager_code"
            label="Код учётной записи менеджера для удаления заказа"
            :items="rk_refs.employees"
            item-text="Title"
            item-value="Code"
          ></v-select>
        </v-col>
        <v-col class="col-4">
          <v-select
            v-model="rk7RefConfig.delete_reason"
            label="Код причины удаления заказа"
            :items="rk_refs.delete_reasons"
            item-text="Title"
            item-value="Code"
          ></v-select>
        </v-col>
        <v-col class="col-4">
          <v-select
            v-model="rk7RefConfig.open_modifier_code"
            label="Код свободного модификатора для добавления комментария к блюду"
            :items="rk_refs.modifiers"
            item-text="Title"
            item-value="Code"
          ></v-select>
        </v-col>
        <v-col class="col-4">
          <v-text-field
            v-model="rk7RefConfig.guid_commment"
            label="GUID расширенного свойства в заказе для комментария"
            hint="Необязательный параметр. GUID указывать без фигурных скобок"
            persistent-hint
          ></v-text-field>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: ["rk7RefConfig", "rk_refs"],
  methods: {
  },
};
</script>

<style>
</style>